import { render, staticRenderFns } from "./tabs-search.vue?vue&type=template&id=77ecc84a&scoped=true"
import script from "./tabs-search.vue?vue&type=script&lang=js"
export * from "./tabs-search.vue?vue&type=script&lang=js"
import style0 from "./tabs-search.vue?vue&type=style&index=0&id=77ecc84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ecc84a",
  null
  
)

export default component.exports